export enum AppErrorCause {
  MISSING_PERMISSION = "missing-permissions",
  JWT_TOKEN = "jwt-token",
  SSO_PROXY = "sso-proxy",
}

export function isAuthError(cause: unknown): boolean {
  return cause === AppErrorCause.JWT_TOKEN || cause === AppErrorCause.SSO_PROXY;
}
